import 'jquery';

export default {
    ready() {
        jQuery("#header-md-hours").hide();
        jQuery("#header-btn-hours").click( function(){
            jQuery("#header-md-hours").slideToggle(100);
        });

        jQuery('#btn-menu').click(function(event) {
            jQuery('#sliding-nav').addClass('active');
        });

        jQuery('#menu-header-menu-2 > li').unbind('click').on("click",function(event){               
          if(jQuery(this).children('ul').hasClass('sub-menu-open')){
            jQuery('#menu-header-menu-2 > li').children('ul').removeClass('sub-menu-open');
          }
          else{
            jQuery('#menu-header-menu-2 > li').children('ul').removeClass('sub-menu-open');
            jQuery(this).children('ul').addClass('sub-menu-open');   
          }
        });

        jQuery('#sliding-nav').click(function(event) {
            jQuery('#sliding-nav').removeClass('active');
        });

        jQuery('#desktop-nav ul li').mouseleave(function(event) {
            if (jQuery(this).children('ul').length > 0) {
            jQuery(this).children('ul').removeClass('sub-menu-open');
            //event.stopPropagation();
            event.preventDefault();
            }
        });
        jQuery('#desktop-nav ul:not(.sub-menu) > li').mouseover(function(event) {
            if (jQuery(this).children('ul').length > 0) {
                
            jQuery(this).children('ul').addClass('sub-menu-open');
            event.stopPropagation();
            event.preventDefault();
            }
        });
        jQuery('#desktop-nav ul.sub-menu > li').mouseover(function(event) {
            if (jQuery(this).children('ul').length > 0) {
            jQuery(this).children('ul').addClass('sub-menu-open');
            jQuery(this).children('ul').css("margin-left", "30px");
            event.stopPropagation();
            event.preventDefault();
            }
        });
        
        jQuery('#sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').unbind('click').click(function(event) {
            jQuery(this).children('ul').children('li').click(function(event) {
                if(jQuery(this).children('ul').length == 0 ){
                    jQuery('#sliding-nav').removeClass('active')
                    event.stopPropagation();
                    return;
                }
            });

            if (jQuery(this).children('ul').length > 0 && jQuery(this).children('ul').hasClass('sub-menu-open')) {
                jQuery(this).children('ul').removeClass('sub-menu-open');
                event.stopPropagation();
                event.preventDefault();

            } else if (jQuery(this).children('ul').length > 0) {
                jQuery('#sliding-nav #desktop-nav-mobile ul li, #sliding-nav #desktop-nav-vertical ul li').not(this).children("ul").removeClass('sub-menu-open');
                jQuery(this).parent().addClass('sub-menu-open');
                jQuery(this).children('ul').addClass('sub-menu-open');
                event.stopPropagation();
                event.preventDefault();
            }
        });

        $( window ).on( "orientationchange", function( event ) {
          jQuery('#sliding-nav').removeClass('active');
        });
    }
}
